import type { CustomerSummary } from "../types";
import { customerStatus, fmtTsShort, classNames } from "../utils";

const STATUS_DOT: Record<ReturnType<typeof customerStatus>, string> = {
  paid: "bg-emerald-500",
  trial: "bg-amber-500",
  prospect: "bg-slate-300",
};

export function CustomerList({
  items,
  selectedId,
  onSelect,
}: {
  items: CustomerSummary[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}) {
  if (items.length === 0) {
    return <div className="px-3 py-4 text-sm text-ink-500">没有匹配的客户</div>;
  }
  return (
    <ul className="min-h-0 flex-1 overflow-y-auto scrollbar-thin divide-y divide-ink-100">
      {items.map((c) => {
        const status = customerStatus(c);
        const label = c.name || c.id;
        const meta: string[] = [];
        if (c.channel) meta.push(c.channel);
        if (status === "paid" && typeof c.price_cny === "number") meta.push(`¥${c.price_cny}`);
        else if (status === "trial") meta.push("试用");
        if (c.license_count > 0) meta.push(`L${c.license_count}`);

        return (
          <li key={c.id}>
            <button
              className={classNames(
                "flex w-full items-center gap-1.5 px-3 py-1.5 text-left text-sm transition-colors",
                selectedId === c.id ? "bg-indigo-50 hover:bg-indigo-100" : "hover:bg-ink-50",
              )}
              onClick={() => onSelect(c.id)}
              title={`${label} · ${c.id}`}
            >
              <span className={classNames("h-1.5 w-1.5 shrink-0 rounded-full", STATUS_DOT[status])} />
              <span className="min-w-0 flex-1 truncate">
                <span className="font-medium">{label}</span>
                {meta.length > 0 && (
                  <span className="text-ink-400"> · {meta.join(" · ")}</span>
                )}
              </span>
              <span className="shrink-0 text-xs tabular-nums text-ink-400">{fmtTsShort(c.updated_at)}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
